import React, { useState, useEffect } from "react";
import Base from "../admin_components/Admin_Base";
import {
  Breadcrumbs,
  Link,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Tooltip,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveSharpIcon from "@mui/icons-material/SaveSharp";
import CancelIcon from "@mui/icons-material/Cancel";

import { ADMIN_API_BASE_URL } from "../Auth/Api";
// import useAxios from "../Auth/useAxios";
import "../AreaPriceDetails/AreaPriceDetails.css";
// import { useApi } from "../Auth/useAxios";
// import { useAuth } from "../Auth/useAuth";
import { ArrowUpward, ArrowDownward, SwapVert } from "@mui/icons-material";
import authAxios from "../Auth/useAxios";
import Swal from "sweetalert2";
import { IconButton } from "@mui/material";
import { ClipLoader } from "react-spinners";

const PlotList = () => {
  const [areas, setAreas] = useState([]);
  const [filteredAreas, setFilteredAreas] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [filterPhase, setFilterPhase] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", order: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchPlots = async () => {
      try {
        const response = await authAxios.get(
          `${ADMIN_API_BASE_URL}/main/admin/get-all-plots`
        );
        setAreas(Array.isArray(response.data) ? response.data : []);
        setFilteredAreas(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching plot data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlots();
  }, []);

  useEffect(() => {
    if (filterPhase) {
      setFilteredAreas(areas.filter((area) => area.phase === filterPhase));
    } else {
      setFilteredAreas(areas);
    }
  }, [filterPhase, areas]);

  const handleSort = (key) => {
    let sortedAreas = [...filteredAreas];

    let newOrder = "asc";
    if (sortConfig.key === key && sortConfig.order === "asc") {
      newOrder = "desc";
    } else if (sortConfig.key === key && sortConfig.order === "desc") {
      newOrder = "";
    }

    setSortConfig({ key, order: newOrder });
  };

  const sortedPlots = [...filteredAreas].sort((a, b) => {
    if (!sortConfig.order) return 0;

    let valueA = a[sortConfig.key];
    let valueB = b[sortConfig.key];

    if (sortConfig.key === "status") {
      valueA = a.active ? 1 : 0;
      valueB = b.active ? 1 : 0;
    } else if (sortConfig.key === "amount") {
      valueA = parseFloat(valueA) || 0;
      valueB = parseFloat(valueB) || 0;
    } else {
      valueA = valueA?.toString().toLowerCase();
      valueB = valueB?.toString().toLowerCase();
    }

    if (sortConfig.order === "asc") return valueA > valueB ? 1 : -1;
    if (sortConfig.order === "desc") return valueA < valueB ? 1 : -1;
    return 0;
  });

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <SwapVert fontSize="small" />;
    return sortConfig.order === "asc" ? (
      <ArrowUpward fontSize="small" />
    ) : (
      <ArrowDownward fontSize="small" />
    );
  };
  const handleEdit = (area) => {
    setEditRow({ ...area });
    setAreas(
      areas.map((a) => (a.id === area.id ? { ...a, isEditing: true } : a))
    );
  };

  const handleChange = (field, value) => {
    setEditRow({ ...editRow, [field]: value });
  };

  const handleSave = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save the changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, cancel!",
    });

    if (!result.isConfirmed) {
      return;
    }

    const token = localStorage.getItem("authToken");

    if (!token) {
      console.error("No authentication token found!");
      return;
    }

    try {
      const response = await authAxios.put(
        `${ADMIN_API_BASE_URL}/main/admin/update-plot/${id}`,
        editRow,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setAreas(
          areas.map((area) =>
            area.id === id ? { ...editRow, isEditing: false } : area
          )
        );
        setEditRow(null);

        Swal.fire({
          title: "Saved!",
          text: "Your changes have been saved successfully.",
          icon: "success",
        });
      } else {
        console.error("Failed to update plot:", response.data);
        Swal.fire({
          title: "Error!",
          text: "Failed to save changes.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error updating plot:", error);
      Swal.fire({
        title: "Error!",
        text: "An error occurred while saving.",
        icon: "error",
      });
    }
  };

  const handleStatusChange = (id, value) => {
    setEditRow((prevState) => ({
      ...prevState,
      active: value === "Available",
    }));
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      console.error("No authentication token found!");
      return;
    }

    const confirmDelete = Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });
    if (confirmDelete) {
      try {
        const response = await authAxios.delete(
          `${ADMIN_API_BASE_URL}/main/admin/delete-plot/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          setAreas(areas.filter((area) => area.id !== id));
        } else {
          console.error("Failed to delete plot:", response.data);
        }
      } catch (error) {
        console.error("Error deleting plot:", error);
      }
    }
  };

  const handleCancel = (id) => {
    setAreas(
      areas.map((area) =>
        area.id === id ? { ...area, isEditing: false } : area
      )
    );
    setEditRow(null);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredAreas]);

  const totalPages = Math.ceil(filteredAreas.length / recordsPerPage);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredAreas.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div
            className="pt-3 mt-5 container res_container"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: "20px",
            }}
          >
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Link
                underline="hover"
                key="1"
                color="inherit"
                href="/admin/dashboard"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Dashboard
              </Link>
              <Link
                underline="none"
                key="2"
                color="inherit"
                href="/admin/plot_list"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Plot List
              </Link>
            </Breadcrumbs>
          </div>

          <h2 className="text-center fw-bold main_heading">Plot List</h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "94%" }} />
          </div>

          <div
            className="container admin_phase_filter"
            style={{ textAlign: "center" }}
          >
            <div style={{ display: "flex", justifyContent: "end", width: "95%" }}>
              <FormControl
                size="small"
                variant="outlined"
                style={{ marginBottom: "10px", width: "200px", textAlign: "end" }}
              >
                <InputLabel>Filter by Phase</InputLabel>
                <Select
                  value={filterPhase}
                  onChange={(e) => setFilterPhase(e.target.value)}
                  label="Filter by Phase"
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="Phase_1">Phase 1</MenuItem>
                  <MenuItem value="Phase_2">Phase 2</MenuItem>
                  <MenuItem value="Phase_3">Phase 3</MenuItem>
                  <MenuItem value="Phase_4">Phase 4</MenuItem>
                </Select>
              </FormControl>
            </div>

            <Table className="table" style={{ margin: "0 auto", width: "90%" }}>
              <Thead
                className="text-white"
                style={{ backgroundColor: "darkslategrey" }}
              >
                <Tr>
                  <Th>S.No</Th>
                  {/* <Th>Phase</Th> */}
                  <th onClick={() => handleSort("phase")}>
                    Phase {getSortIcon("phase")}
                  </th>

                  {/* <Th>Plot No.</Th> */}
                  <th onClick={() => handleSort("plotNo")}>
                    Plot No {getSortIcon("plotNo")}
                  </th>
                  <Th>Direction</Th>
                  <Th style={{ width: "15%" }}>Area</Th>
                  {/* <Th>Amount</Th> */}

                  <th onClick={() => handleSort("amount")}>
                    Amount {getSortIcon("amount")}
                  </th>

                  <th onClick={() => handleSort("status")}>
                    Status {getSortIcon("status")}
                  </th>

                  <th onClick={() => handleSort("status")}>
                    Status {getSortIcon("status")}
                  </th>
                </Tr>
              </Thead>
              <Tbody>
                {currentRecords.map((area, index) => (
                  <Tr key={area.id || index}>
                    <Td>{index + 1}</Td>

                    {/* Handle rendering phase, safely check for objects */}
                    <Td>
                      {area.isEditing ? (
                        <Select
                          value={editRow?.phase || ""}
                          onChange={(e) => handleChange("phase", e.target.value)}
                          variant="outlined"
                          size="small"
                          style={{ width: "100%" }}
                        >
                          <MenuItem value="Phase 1">Phase 1</MenuItem>
                          <MenuItem value="Phase 2">Phase 2</MenuItem>
                          <MenuItem value="Phase 3">Phase 3</MenuItem>
                          <MenuItem value="Phase 4">Phase 4</MenuItem>
                        </Select>
                      ) : typeof area.phase === "object" ? (
                        JSON.stringify(area.phase)
                      ) : (
                        area.phase ?? "N/A"
                      )}
                    </Td>

                    {/* Handle rendering plotNumber safely */}
                    <Td>
                      {area.isEditing ? (
                        <TextField
                          value={editRow?.plotNumber || ""}
                          onChange={(e) =>
                            handleChange("plotNumber", e.target.value)
                          }
                          variant="outlined"
                          size="small"
                        />
                      ) : typeof area.plotNumber === "object" ? (
                        JSON.stringify(area.plotNumber)
                      ) : (
                        area.plotNumber ?? "N/A"
                      )}
                    </Td>

                    {/* Handle rendering plotDirection safely */}
                    <Td>
                      {area.isEditing ? (
                        <TextField
                          value={editRow?.plotDirection || ""}
                          onChange={(e) =>
                            handleChange("plotDirection", e.target.value)
                          }
                          variant="outlined"
                          size="small"
                        />
                      ) : typeof area.plotDirection === "object" ? (
                        JSON.stringify(area.plotDirection)
                      ) : (
                        area.plotDirection ?? "N/A"
                      )}
                    </Td>

                    <Td>
                      <Tooltip
                        // title={
                        //   area?.area && typeof area.area === "object"
                        //     ? JSON.stringify(area.area)
                        //     : area.area ?? "N/A"
                        // }
                        title={"cannot change this value"}
                      >
                        <span>
                          {area.isEditing ? (
                            <TextField
                              value={editRow?.area.area ?? "N/A"}
                              onChange={(e) => handleChange("area", e.target.value)}
                              variant="outlined"
                              size="small"
                              disabled
                            />
                          ) : (
                            area?.area?.area ?? "N/A"
                          )}
                        </span>
                      </Tooltip>
                    </Td>

                    {/* Handle rendering plotAmount safely */}
                    <Td>
                      {area.isEditing ? (
                        <TextField
                          value={editRow?.plotAmount || ""}
                          onChange={(e) =>
                            handleChange("plotAmount", e.target.value)
                          }
                          variant="outlined"
                          size="small"
                        />
                      ) : typeof area.plotAmount === "object" ? (
                        JSON.stringify(area.plotAmount)
                      ) : (
                        area.plotAmount ?? "N/A"
                      )}
                    </Td>
                    <Td
                      style={{
                        fontWeight: "bold",
                        color: area.active ? "green" : "red",
                      }}
                    >
                      {area.isEditing ? (
                        <Select
                          value={editRow?.active ? "Available" : "Booked"}
                          onChange={(e) =>
                            handleStatusChange(area.id, e.target.value)
                          }
                          variant="outlined"
                          size="small"
                          style={{ width: "100%" }}
                        >
                          <MenuItem value="Booked" style={{ color: "red" }}>
                            Booked
                          </MenuItem>
                          <MenuItem value="Available" style={{ color: "green" }}>
                            Available
                          </MenuItem>
                        </Select>
                      ) : area.active ? (
                        "Available"
                      ) : (
                        "Booked"
                      )}
                    </Td>
                    <Td className="saveandedit_cont">
                      {area.isEditing ? (
                        <div style={{ display: "flex", gap: "5px" }}>
                          <Tooltip title="save">
                            <IconButton
                              onClick={() => handleSave(area.id)}
                              className="border-0 text-success"
                            >
                              <SaveSharpIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Cancel">
                            <IconButton
                              onClick={() => handleCancel(area.id)}
                              className="border-0"
                              style={{ color: "red" }}
                            >
                              <CancelIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ) : (
                        <div>
                          <Tooltip title="edit">
                            <IconButton
                              onClick={() => handleEdit(area)}
                              className="border-0 text-primary"
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="delete">
                            <IconButton
                              onClick={() => handleDelete(area.id)}
                              className="border-0"
                              style={{ color: "red" }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      )}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
          <div
            className="pagination-container"
            style={{ marginTop: "20px", textAlign: "center" }}
          >
            <button
              onClick={prevPage}
              disabled={currentPage === 1}
              style={{
                backgroundColor: currentPage === 1 ? "#ccc" : "#007bff",
                color: "white",
                padding: "8px 15px",
                border: "none",
                borderRadius: "5px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                marginRight: "10px",
              }}
            >
              Previous
            </button>

            <span style={{ fontSize: "16px", fontWeight: "bold" }}>
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={nextPage}
              disabled={currentPage === totalPages}
              style={{
                backgroundColor: currentPage === totalPages ? "#ccc" : "#007bff",
                color: "white",
                padding: "8px 15px",
                border: "none",
                borderRadius: "5px",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                marginLeft: "10px",
              }}
            >
              Next
            </button>
          </div>
        </>
      )}
    </Base>
  );
};

export default PlotList;
